import { GridSortItem } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import {
  DGT_Pagination,
  getConfigObject,
  getPageIndexWhileSearch,
  useBaseData,
} from "../../../utils/utils";
import { ScreenerControllerApi } from "../../../services";

interface Props {
  pagination: DGT_Pagination;
  gridSorting?: GridSortItem[];
  isPublicView?: boolean;
  type: string;
  xTENANTID?: string;
  enabled?: boolean;
}

/**
 *
 * @author Rajkumar Rathod
 */
export const useScreeningList = ({
  pagination,
  isPublicView,
  gridSorting,
  type,
  xTENANTID,
  enabled = true,
}: Props): useBaseData<any> => {
  const prevPage = useRef<number>(pagination.page);

  const pageIndex = getPageIndexWhileSearch({
    pagination,
    searchKey: "",
    prevPage,
  });

  const sortDirect = gridSorting?.[0]?.sort ?? undefined;
  const sortBy = sortDirect ? "firstName" : undefined;

  return useQuery({
    queryKey: [
      "encounter-screening-list",
      pagination,
      gridSorting,
      type,
      xTENANTID,
    ],
    enabled: enabled && !!type,
    refetchOnWindowFocus: false,
    queryFn: async () =>
      await new ScreenerControllerApi(
        isPublicView ? undefined : getConfigObject()
      )
        .getScreenerByType(
          type,
          pageIndex, //page
          pagination.pageSize, //size
          sortBy,
          sortDirect, // sortDirection
          xTENANTID // xTENANTID
        )
        .then((res) => res?.data),
  });
};
